import { render, staticRenderFns } from "./service-selection-modal.vue?vue&type=template&id=63e1fb6e&scoped=true"
import script from "./service-selection-modal.vue?vue&type=script&lang=js"
export * from "./service-selection-modal.vue?vue&type=script&lang=js"
import style0 from "./service-selection-modal.vue?vue&type=style&index=0&id=63e1fb6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e1fb6e",
  null
  
)

export default component.exports